import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';

import window from '@/utils/window';

/**
 *
 * @param {element} targetElement - element to scroll
 * @param {boolean} shouldStartScrolling - indicates that the scrolling should start
 *
 * scroll to element if the URL has a hash and the element exist in the VDOM
 */
const useScrollToElementInHash = (targetElement, shouldStartScrolling = false) => {
    const location = useLocation();
    // passing the window.location as fallback
    const hash = location?.hash && location.hash !== '' ? location.hash : window.location.hash;
    const hashRef = useRef(hash);

    useEffect(() => {
        if (hash && shouldStartScrolling) {
            // We need to reset if the hash has changed
            if (hashRef.current !== hash) {
                hashRef.current = hash;
            }

            // hash and element ID should be the same
            if (targetElement?.current && `#${targetElement.current?.id}` === hashRef.current) {
                targetElement.current.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, [hash, targetElement, shouldStartScrolling]);
};

export default useScrollToElementInHash;
